export default __webpack_public_path__ + "static/media/fabien-bazanegue.3c5ff5a0.jpg";